import React from "react";
import { Card, Button, ButtonGroup, TextContainer } from "@shopify/polaris";

export default function CreateCheckCalloutCard({
  secondaryAction,
  primaryAction,
}) {
  return (
    <Card sectioned>
      <div style={{ display: "flex", gap: "20px", alignItems: "stretch" }}>
        <div style={{ flex: 1 }}>
          <TextContainer>
            <h2 style={{ fontWeight: 600, fontSize: "16px" }}>
              Verify your customers real life identities with an ID check.
            </h2>
            <p>
              Create an ID check to verify your customers real life identity.
            </p>
            <p>
              Real ID will verify the authenticity of your customer's government
              issued IDs with an option headshot to compare them against.
            </p>
          </TextContainer>
          <div style={{ marginTop: "16px" }}>
            <ButtonGroup>
              {primaryAction && (
                <Button onClick={primaryAction.onAction}>
                  {primaryAction.content}
                </Button>
              )}
              {secondaryAction && (
                <Button plain url={secondaryAction.url} onClick={secondaryAction.onAction}>
                  {secondaryAction.content}
                </Button>
              )}
            </ButtonGroup>
          </div>
        </div>
        <div
          style={{
            flex: "0 0 280px",
            marginTop: "-20px",
            marginBottom: "-20px",
            marginRight: "-20px",
            borderRadius: "0 8px 8px 0",
            overflow: "hidden",
          }}
        >
          <img
            src="https://res.cloudinary.com/tinyhouse/image/upload/q_auto,f_auto/v1775667603/Real%20ID/APp/app_homepage.png"
            alt="ID verification"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
      </div>
    </Card>
  );
}
